<template>
    <section class="inner">
        <Content><div class="box" v-html="data.content"></div></Content>
    </section>
</template>

<script>

import Content from '@/components/ui/Content.vue';

export default {
    name: 'content-block',

    props: {
      data: Object,
    },

    components: {
      Content,
    },

}
</script>

<style lang="scss">
    // .content-block {


    //     &.color-green .ui-enter {
    //         background: var(--footer-3);
    //         padding: var(--padding) var(--padding-x2);
    //     }

    //     &.color-gray .ui-enter {
    //         background: var(--light-gray);
    //         padding: var(--padding) var(--padding-x2);
    //     }
    // }


</style>
